import React, { useState } from 'react';
import {
  IconBuilding, IconSpray, IconCar, IconShieldCheck, IconShoppingCart,
  IconArmchair, IconCoffee, IconStretching, IconVaccine, IconPill, IconPlane, IconBed, IconCloud, IconCreditCard, IconLanguage
} from '@tabler/icons-react';

const ICON_MAP = {
  'ti-building': IconBuilding,
  'ti-spray': IconSpray,
  'ti-car': IconCar,
  'ti-shield-check': IconShieldCheck,
  'ti-shopping-cart': IconShoppingCart,
  'ti-armchair': IconArmchair,
  'ti-coffee': IconCoffee,
  'ti-stretching': IconStretching,
  'ti-vaccine': IconVaccine,
  'ti-pill': IconPill,
  'ti-plane': IconPlane,
  'ti-bed': IconBed,
  'ti-cloud': IconCloud,
  'ti-credit-card': IconCreditCard,
};

const ORDER = ['real_estate','cleaning','car_dealership','insurance','retail','furniture','fnb','physio','derma','pharmacy','tourism','hotels','saas'];

export default function IndustrySelector({ lang, t, onSelect, onToggleLang }) {
  const [hovered, setHovered] = useState(null);
  const { INDUSTRIES } = require('../data/industries');

  return (
    <div style={{
      minHeight: '100vh', background: '#1A1A2E', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', padding: '40px 20px', position: 'relative'
    }}>
      {/* Lang toggle */}
      <button onClick={onToggleLang} style={{
        position: 'absolute', top: 20, [lang === 'ar' ? 'left' : 'right']: 20,
        background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: 8, padding: '8px 16px',
        color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, fontSize: 14
      }}>
        <IconLanguage size={18} />
        {lang === 'ar' ? 'EN' : 'عربي'}
      </button>

      {/* Logo */}
      <div style={{ marginBottom: 12, color: '#fff', fontSize: 42, fontWeight: 800, letterSpacing: -1 }}>
        <span style={{ color: '#7B4FAE' }}>ω</span> tkana
      </div>
      <div style={{ color: '#7B4FAE', fontSize: 13, letterSpacing: 3, marginBottom: 40, fontWeight: 600, textTransform: 'uppercase' }}>
        AIDA PLATFORM
      </div>

      <h1 style={{ color: '#fff', fontSize: 28, fontWeight: 700, marginBottom: 8 }}>{t.selectIndustry}</h1>
      <p style={{ color: '#9CA3AF', fontSize: 15, marginBottom: 40 }}>{t.selectIndustryDesc}</p>

      {/* 3x3 grid */}
      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16,
        maxWidth: 720, width: '100%'
      }}>
        {ORDER.map(id => {
          const ind = INDUSTRIES[id];
          if (!ind) return null;
          const Icon = ICON_MAP[ind.icon] || IconBuilding;
          const isHovered = hovered === id;
          return (
            <div
              key={id}
              onMouseEnter={() => setHovered(id)}
              onMouseLeave={() => setHovered(null)}
              onClick={() => onSelect(id)}
              style={{
                background: isHovered ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.04)',
                borderRadius: 12, padding: '28px 20px', cursor: 'pointer',
                border: `2px solid ${isHovered ? ind.color : 'transparent'}`,
                transition: 'all 0.3s cubic-bezier(0.4,0,0.2,1)',
                transform: isHovered ? 'translateY(-2px)' : 'none',
                textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12
              }}
            >
              <div style={{
                width: 48, height: 48, borderRadius: 12, background: ind.color + '22',
                display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>
                <Icon size={24} color={ind.color} stroke={1.8} />
              </div>
              <span style={{ color: '#fff', fontSize: 15, fontWeight: 600 }}>
                {lang === 'ar' ? ind.nameAr : ind.name}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
